// max len these are the max lengths for the fields in the backend
export const PASSWORD_MAX_LENGTH = 50;
export const USERNAME_MAX_LENGTH = 50;
export const DISPLAY_NAME_MAX_LENGTH = 100;
export const LEGAL_NAME_MAX_LENGTH = 150;
export const FIRST_NAME_MAX_LENGTH = 100;
export const LAST_NAME_MAX_LENGTH = 50;
export const PROFILE_BIO_MAX_LENGTH = 300;
export const MAX_IMAGES_IN_POST = 4;
export const MAX_MESSAGE_CONTENT_LENGTH = 2000;
export const MAX_CHAT_PAGINATION_LENGTH = 50;

// allowed chars in username
export const ALLOWED_USERNAME = "[A-Za-z0-9_]+";

export const DISPLAY_NAME_MAX_LENGTH_POST_DISPLAY = 30;
export const HANDLE_MAX_WIDTH_POST_DISPLAY = 15;
